import type React from 'react'
import { useIntercom } from 'react-use-intercom'

import type { ButtonProps } from '@components/ui/Buttons'
import { Button, IconButton } from '@components/ui/Buttons'

import { getIntercomAppId } from './helpers'
import { useIntercomProps } from './useIntercomProps'

function IntercomButton({ onClick, ...rest }: ButtonProps) {
  const { show } = useIntercom()

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    show()
    onClick?.(event)
  }

  return <Button {...rest} onClick={handleClick} />
}

export function IntercomLauncherButton({
  children,
  className,
  onClick,
  variant = 'primaryContained',
  ...rest
}: ButtonProps) {
  const Component = getIntercomAppId() ? IntercomButton : Button
  const props = useIntercomProps(className, onClick)
  return (
    <Component variant={variant} {...rest} {...props}>
      {children}
    </Component>
  )
}

function IntercomIconButton({ onClick, ...rest }: ButtonProps) {
  const { show } = useIntercom()

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    show()
    onClick?.(event)
  }

  return <IconButton {...rest} onClick={handleClick} />
}

export function IntercomLauncherIconButton({ children, className, onClick, ...rest }: ButtonProps) {
  const Component = getIntercomAppId() ? IntercomIconButton : IconButton
  const props = useIntercomProps(className, onClick)
  return (
    <Component {...rest} {...props}>
      {children}
    </Component>
  )
}
